export default "__VITE_ASSET__DS5CgMf0__"